import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { Busca, Orcamento } from 'src/app/model';
import { toDateTime } from 'src/app/utils/luxon.helper';

export const BUSCA = 'busca';
export const ORCAMENTO = 'orcamentousuario';

@Component({
  selector: 'app-lista-pacotes',
  templateUrl: './lista-pacotes.component.html',
  styleUrls: ['./lista-pacotes.component.scss'], standalone: false
})
export class ListaPacotesComponent implements OnInit {
  Orcamento: Orcamento = new Orcamento();
  busca: Busca = new Busca();
  eventsSubject: Subject<void> = new Subject<void>();

  constructor(
    private _router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit() { }

  aba() {
    if (this.route.snapshot.params.tipo != null) {
      return this.route.snapshot.params.tipo;
    } else {
      let x = this._router.url.split('/');
      return x[x.length - 1];
    }
  }

  rota(texto) {
    this._router.navigate([`/listagem-pacotes/${texto}`]);
  }

  atualizarOrcamento(event, adicionou) {
    window.sessionStorage.setItem(ORCAMENTO, JSON.stringify(this.Orcamento));
  }

  atualizarBusca(busca: Busca) {
    this.busca = this.busca.decodeBuscaNovo(JSON.stringify(busca));
    this.busca.trechos.forEach((trecho) => {
      trecho.dataIda = toDateTime(trecho.dataIda.toString());
      trecho.dataVolta = toDateTime(trecho.dataVolta.toString());
    });

    this.cdr.detectChanges();
  } 

  rotaAnterior() {
    const tipo = this.route.snapshot.params.tipo;
    switch (tipo) {
      case 'pacote-hotel':
        return this.rota('/pacotes');
      case 'pre-orcamento':
        return this.rota('/pacote-hotel');
    }
  }

  rotaAvancar() {
    const tipo = this.route.snapshot.params.tipo;
    switch (tipo) {
      case 'pacotes':
        return this.rota('/pacote-hotel');
      case 'pacote-hotel':
        return this.rota('/pre-orcamento');
      case 'pacote-servico':
        return this.rota('/pre-orcamento');
    }
  }

}
